// extracted by mini-css-extract-plugin
export default {"loginForm":"forms_loginForm__1+B78","forgotPassword":"forms_forgotPassword__guOUy"};